"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GenericRepo_1 = __importDefault(require("./GenericRepo"));

var ItemsRepo =
/** @class */
function (_super) {
  __extends(ItemsRepo, _super);

  function ItemsRepo(app, coll, user) {
    var _this = _super.call(this, coll, user) || this;

    _this.app = app;
    return _this;
  }

  ItemsRepo.prototype.countByRef = function (ref) {
    var qry = {};

    if (Array.isArray(ref)) {
      qry = {
        ref: {
          $in: ref
        }
      };
    } else {
      qry = {
        ref: ref
      };
    }

    return this.coll.count(qry);
  };

  ItemsRepo.prototype.listByRef = function (ref, sort, projection) {
    if (sort === void 0) {
      sort = {
        label: 1,
        _id: 1
      };
    }

    if (projection === void 0) {
      projection = {};
    }

    var qry = {};

    if (Array.isArray(ref)) {
      qry = {
        ref: {
          $in: ref
        }
      };
    } else {
      qry = {
        ref: ref
      };
    }

    return this.find(qry, sort, projection);
  };

  ItemsRepo.prototype.findExistingRefs = function (refs) {
    var _this = this;

    return new Promise(function (res, rej) {
      var map = new Map();

      _this.coll.find({
        ref: {
          $in: refs
        }
      }, {
        projection: {
          _id: 1,
          ref: 1
        }
      }).toArray().then(function (items) {
        var e_1, _a;

        try {
          for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var item = items_1_1.value;
            map.set(item.ref.toLowerCase(), item._id);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }

        res(map);
      }).catch(rej);
    });
  };

  ItemsRepo.prototype.listByTypes = function (types, sort) {
    if (sort === void 0) {
      sort = {
        place: 1,
        label: 1
      };
    }

    return this.coll.find({
      types: {
        $in: types
      }
    }, {
      sort: sort
    }).asArray();
  };

  ItemsRepo.prototype.update = function (o) {
    var _this = this;

    return new Promise(function (res, rej) {
      o.modified = new Date();
      var op = {
        $set: o,
        $addToSet: {}
      };
      var refs = [];

      if (o.ref) {
        refs.push(o.ref);
      }

      if (o.altRefs) {
        refs.push.apply(refs, __spread(o.altRefs));
      }

      if (refs.length > 0) {
        op["$addToSet"] = {
          refs: {
            $each: refs
          }
        };
      } else {
        delete op["$addToSet"];
      }

      _this.coll.updateOne({
        _id: o._id
      }, op).then(function () {
        _this.emitter.emit("updated", o._id, o);

        res(o._id);
      }).catch(rej);
    });
  };

  ItemsRepo.prototype.save = function (o) {
    o.refs = __spread([o.ref], o.altRefs || []);
    return _super.prototype.save.call(this, o);
  };

  ItemsRepo.prototype.batch = function (batch) {
    return this.app.callFunction("itemsBatch", [batch]);
  };

  return ItemsRepo;
}(GenericRepo_1.default);

exports.default = ItemsRepo;